"use client";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { noop } from "../../../utils/index.js";
import { Button } from "../../Button/index.js";
import { CdnIcon } from "../../CdnIcon/index.js";
import { Disclaimer } from "../../Disclaimer/index.js";
import { Divider } from "../../Divider/index.js";
import { StatusBanner } from "../../StatusBanner/index.js";
import { DEFAULT_MAX_ROOMS, HOTEL_CHILD_DISCLAIMER, ROOM_SIZE } from "../constants.js";
import ChildrenLineItem from "../TravelerLineItems/ChildrenLineItem.js";
import { MaxRoomsBannerMessage } from "../TravelerLineItems/MaxRoomsBannerMessage.js";
import TravelerLineItem from "../TravelerLineItems/TravelerLineItem.js";
function TravelerSelectionContent({ ageSelectEnabled, disclaimer, isHotel, displayDoneButton, maxAdults, maxChildren, fireMaxRoomsOnClick, maxRooms: defaultMaxRooms = DEFAULT_MAX_ROOMS, maxRoomsMessage, maxRoomsUrl, roomsEnabled, state = {}, handleClose, subLabelMap, lapInfantLabel, shouldCountLapInfant }) {
    const { rooms = 1, adults = 1, children = 0, childrenAges = {}, lapInfants = 0, remainingTravelerCount = 0, setRooms = noop, setAdults = noop, setChildren = noop, setChildrenAges = noop, setLapInfants = noop, triggerValidation = noop } = state;
    const maxRooms = ageSelectEnabled && roomsEnabled && maxAdults && maxChildren ? Math.ceil((maxAdults + maxChildren) / ROOM_SIZE) : defaultMaxRooms;
    const finalMaxLapInfant = shouldCountLapInfant ? Math.min(adults, lapInfants + remainingTravelerCount) : adults;
    const finalMaxChildren = maxChildren ? Math.min(maxChildren, children + remainingTravelerCount) : children + remainingTravelerCount;
    const BannerMessage = useMemo(()=>/*#__PURE__*/ jsx(MaxRoomsBannerMessage, {
            maxRoomsMessage: maxRoomsMessage,
            maxRoomsUrl: maxRoomsUrl,
            fireMaxRoomsOnClick: fireMaxRoomsOnClick,
            maxRooms: maxRooms
        }), [
        maxRoomsMessage,
        maxRoomsUrl,
        fireMaxRoomsOnClick,
        maxRooms
    ]);
    const handleDoneClick = (e)=>{
        triggerValidation();
        handleClose?.(e);
    };
    return /*#__PURE__*/ jsxs("div", {
        className: "no-scrollbar flex h-full w-full cursor-pointer flex-col overflow-x-hidden overflow-y-scroll",
        children: [
            roomsEnabled ? /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(TravelerLineItem, {
                        label: "Rooms",
                        min: 1,
                        max: maxRooms,
                        count: rooms,
                        onChange: setRooms
                    }),
                    rooms === maxRooms ? /*#__PURE__*/ jsx(StatusBanner, {
                        palette: "caution",
                        emphasis: "medium",
                        captionNode: BannerMessage,
                        iconNode: /*#__PURE__*/ jsx(CdnIcon, {
                            iconName: "bed"
                        })
                    }) : null,
                    /*#__PURE__*/ jsx(Divider, {})
                ]
            }) : null,
            /*#__PURE__*/ jsx(TravelerLineItem, {
                label: "Adults",
                subLabel: subLabelMap?.adults ?? '',
                min: 1,
                max: maxAdults || adults + remainingTravelerCount,
                count: adults,
                onChange: setAdults
            }),
            /*#__PURE__*/ jsx(Divider, {}),
            /*#__PURE__*/ jsx(ChildrenLineItem, {
                ageSelectEnabled: ageSelectEnabled,
                max: finalMaxChildren,
                count: children,
                ages: childrenAges,
                isHotel: isHotel,
                onChange: setChildren,
                subLabel: subLabelMap?.children ?? 'Ages 2 to 11',
                onAgeChange: setChildrenAges
            }),
            ageSelectEnabled ? null : /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(Divider, {}),
                    /*#__PURE__*/ jsx(TravelerLineItem, {
                        label: lapInfantLabel ?? 'Infants on Lap',
                        subLabel: subLabelMap?.lapInfants ?? 'Under 2',
                        min: 0,
                        max: finalMaxLapInfant,
                        count: lapInfants,
                        onChange: setLapInfants
                    })
                ]
            }),
            disclaimer ? /*#__PURE__*/ jsx(Disclaimer, {
                className: "pt-2 text-body3",
                children: disclaimer
            }) : null,
            !disclaimer && roomsEnabled && ageSelectEnabled ? /*#__PURE__*/ jsx(Disclaimer, {
                className: "no-scrollbar pt-2 text-body3",
                children: HOTEL_CHILD_DISCLAIMER
            }) : null,
            displayDoneButton ? /*#__PURE__*/ jsx("div", {
                className: "mt-3 flex justify-end",
                children: /*#__PURE__*/ jsx(Button, {
                    size: "sm",
                    type: "primary",
                    onClick: handleDoneClick,
                    children: "Done"
                })
            }) : null
        ]
    });
}
export { TravelerSelectionContent };
